
import React from 'react';
import { t, validateNonEmpty } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
    ControlPanelsContainerProps,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { commonControlsConfig } from '../utils';

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
    {
      ...sections.legacyRegularTime,
      expanded: false
    },
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        [
          {
            name: 'enable_drill_down',
            config: {
              type: 'CheckboxControl',
              label: t('Enable DrillDown'),
              renderTrigger: false,
              default: DEFAULT_FORM_DATA.enableDrillDown,
              description: t('To enable selection of multiple columns for DrillDown Query.'),
            },
          },
        ],
        [
          {
            name: 'groupby',
            config: {
              ...sharedControls.groupby,
              multi: false,
              clearable: false,
              validators: [validateNonEmpty]
            }
          }
        ],
        [
          {
            name: 'drill_down_groupby',
            config: {
              ...sharedControls.groupby,
              multi: true,
              label: t('Drilldown Columns'),
              description: t('Column values to use as categories for each level.'),
              visibility: ({ controls }: ControlPanelsContainerProps) =>
                Boolean(controls?.enable_drill_down?.value),
            },
          },
        ],
        ['metric'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
              name: 'row_limit',
              config: {
              ...sharedControls.row_limit,
              default: 10,
              },
          },
        ]
       ],
     },
     {
       label: t('Chart Options'),
       tabOverride: 'customize',
       expanded: false,
       controlSetRows: [
        //  ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
         [
            {
              name: 'show_labels',
              config: {
                type: 'CheckboxControl',
                label: t('Show Labels'),
                renderTrigger: true,
                default: DEFAULT_FORM_DATA.showLabels,
                description: t('Whether to display the labels.'),
              },
           },
         ],

         [
          {
            name: 'tooltipFormat',
            config: {
              ...commonControlsConfig.tooltipFormat,
              default: DEFAULT_FORM_DATA.tooltipFormat,
            },
          }
         ],
         [
            {
              name: 'backgroundImage',
              config: {
                ...commonControlsConfig.image,
                label: t('Background Pattern Image'),
                default: DEFAULT_FORM_DATA.backgroundImage,
              },
            },
          ],
          [
            {
              name: 'pieImage',
              config: {
                ...commonControlsConfig.image,
                label: t('Pie Patten Image'),
                default: DEFAULT_FORM_DATA.pieImage,
              },
            },
          ],
          [
            {
              name: 'LabelColor',
              config: {
                ...sharedControls.color_picker,
                label: t('Label Color'),
                default: DEFAULT_FORM_DATA.labelColor,
                renderTrigger: true
              },
            },
          ],
          [
            {
              name: 'labelLineColor',
              config: {
                ...sharedControls.color_picker,
                label: t('Lable Line Color'),
                default: DEFAULT_FORM_DATA.labelLineColor,
                renderTrigger: true
              },
            },
          ],
          [
            {
              name: 'labelPosition',
              config: {
                ...commonControlsConfig.labelPosition,
                default: DEFAULT_FORM_DATA.labelPosition,
              },
            }
          ],
          [
            {
              name: 'labelAlignment',
              config: {
                ...commonControlsConfig.labelAlignment,
                default: DEFAULT_FORM_DATA.labelAlignment,
              },
            }
          ],
          [
            {
              name: 'borderColor',
              config: {
                ...sharedControls.color_picker,
                label: t('Border Color'),
                default: DEFAULT_FORM_DATA.borderColor,
                renderTrigger: true
              },
            },
          ],
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => ({
     ...formData,
     metric: formData.standardizedFormData.standardizedState.metrics[0],
     groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 